import type { BlogPost } from "@/hooks/api/blogPosts";
import { BlogCard } from "./BlogCard";

interface RelatedArticlesProps {
  currentSlug: string;
  posts: BlogPost[];
}

export function RelatedArticles({ currentSlug, posts }: RelatedArticlesProps) {
  // Filter out current article and take 3 most recent
  const relatedPosts = posts
    .filter((post) => post.slug !== currentSlug)
    .slice(0, 3);

  // Don't show section if less than 2 articles available
  if (relatedPosts.length < 2) {
    return null;
  }

  return (
    <section className="mt-16 pt-12 border-t border-border">
      <h2 className="text-2xl font-bold text-foreground mb-8">À lire aussi</h2>
      <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
        {relatedPosts.map((post) => (
          <BlogCard key={post.id} post={post} />
        ))}
      </div>
    </section>
  );
}
